import React from "react";
import getServer from "@/utils/functions/function";
import dynamic from "next/dynamic";

const ContactPage = dynamic(() => import("@/components/pages/ContactPage"), {
  ssr: false,
});

const Contact = ({ data }) => {
  return <ContactPage data={data} />;
};

export default Contact;

export async function getServerSideProps(context) {
  return await getServer(context);
}
